import { BaseBlockProps } from '../../defs/block';

export type BarrelBlockID = 'barrel';

export type BarrelBlockType = 'barrel';

export type BarrelBlockProps = {
  type: BarrelBlockType;
} & BaseBlockProps;

export const barrelBlockProps: Record<BarrelBlockID, BarrelBlockProps> = {
  barrel: {
    id: 'ba',
    type: 'barrel',
    immobile: true,
    options: [
      { count: 5 },
      { count: 4 },
      { count: 3 },
      { count: 2 },
      { count: 1 },
      { count: 0 },
    ],
    optionType: 'list',
  },
};
